import { BRAND, LAYOUT, primaryButtonSx } from "../../components/auth/authTheme";

export { BRAND, primaryButtonSx };

export const dashCardSx = {
  borderRadius: LAYOUT.cardRadius,
  border: `1px solid ${BRAND.border}`,
  boxShadow: "0 2px 12px rgba(26, 43, 74, 0.05)",
  bgcolor: "#fff",
  overflow: "hidden",
};

export const dashCardHeaderSx = {
  bgcolor: "#fff",
  color: BRAND.navy,
  borderBottom: `1px solid ${BRAND.border}`,
  py: 1.5,
  "& .MuiCardHeader-title": {
    fontWeight: 700,
    fontSize: "1rem",
    color: BRAND.navy,
  },
  "& .MuiCardHeader-subheader": {
    color: BRAND.muted,
    fontSize: "0.8125rem",
  },
};

export const dashDividerSx = {
  borderColor: BRAND.border,
  opacity: 1,
};

export const profileGradient = `linear-gradient(145deg, ${BRAND.navy} 0%, #243656 55%, ${BRAND.orangeHover} 140%)`;

export const fieldLabelSx = {
  fontSize: "0.6875rem",
  fontWeight: 600,
  color: BRAND.muted,
  textTransform: "uppercase",
  letterSpacing: "0.05em",
  mb: 0.35,
};

export const fieldValueSx = {
  fontSize: "0.9375rem",
  fontWeight: 600,
  color: BRAND.navy,
  lineHeight: 1.4,
  wordBreak: "break-word",
};

export const punchInSx = {
  ...primaryButtonSx,
  bgcolor: BRAND.success,
  minWidth: 120,
  "&:hover": { bgcolor: BRAND.successHover },
};

export const punchOutSx = {
  ...primaryButtonSx,
  bgcolor: BRAND.orange,
  minWidth: 120,
  "&:hover": { bgcolor: BRAND.orangeHover },
};

export const pieColors = [BRAND.navy, "#22c55e", BRAND.orangeHover];

export const statIconSx = (color) => ({
  width: 32,
  height: 32,
  bgcolor: color,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "8px",
  color: "#fff",
});

export const STAT_ICON_COLORS = [
  BRAND.orangeHover,
  BRAND.navy,
  "#3B82F6",
  "#EC4899",
];

export const holidayCardSx = {
  ...dashCardSx,
  background: `linear-gradient(135deg, ${BRAND.orangeLight} 0%, #fff 100%)`,
  border: `1px solid ${BRAND.orange}33`,
  p: 2,
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  minHeight: 100,
};

export const birthdayItemSx = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  mb: 1.5,
  p: 1,
  border: `1px dashed ${BRAND.border}`,
  borderRadius: "10px",
  bgcolor: BRAND.bg,
};
